/**
 * Manage company site pages
 */
import Ajax from '@/lib/ajax_wrapper'
import {authHeader, request} from '@/lib/request'

function articlesPath(companyId, siteId) {
  return `/admin/companies/${companyId}/sites/${siteId}/articles`
}

function articlePath(companyId, siteId, id) {
  return `${articlesPath(companyId, siteId)}/${id}`
}
/**
 * Read paginated company site articles
 *
 * @param {string} companyId
 * @param {string} siteId
 * @param {object} pagination
 * @param {integer} pagination.number
 * @param {integer} paginatino.perPage
 *
 * @returns {promise}
 */
export function readCompanySiteArticlesData(companyId, siteId, pagination) {
  return Ajax.request({
    url: articlesPath(companyId, siteId),
    page: pagination
  })
}

/**
 * Create a company site article
 *
 * @param {string} companyId
 * @param {string} siteId
 * @param {object} article
 * @param {string} article.heading
 * @param {string} article.content_md
 *
 * @returns {promise}
 */
export function createCompanySiteArticleData(companyId, siteId, article) {
  return Ajax.request({
    url: articlesPath(companyId, siteId),
    method: 'POST',
    data: {article}
  })
}

/**
 * Read a company site article
 *
 * @param {string} companyId
 * @param {string} siteId
 * @param {string} id
 *
 * @returns {promise}
 */
export function readCompanySiteArticleData(companyId, siteId, id) {
  return Ajax.request({
    url: articlePath(companyId, siteId, id)
  })
}

/**
 * Update a company site article
 *
 * @param {string} companyId
 * @param {string} siteId
 * @param {string} id
 * @param {object} article
 * @param {string} article.heading
 * @param {string} article.content_md
 *
 * @returns {promise}
 */
export function updateCompanySiteArticleData(companyId, siteId, id, article) {
  return Ajax.request({
    url: articlePath(companyId, siteId, id),
    method: 'PATCH',
    data: {article}
  })
}

export function updateCompanySiteArticleImage(
  companyId,
  siteId,
  id,
  data,
  token
) {
  const method = 'PATCH'
  const url = `/${articlePath(companyId, siteId, id)}/featured_image`
  const headers = authHeader(token)

  return request({data, headers, method, url})
    .then((xhr) => {
      return JSON.parse(xhr.responseText)
    })
    .catch((xhr) => {
      return JSON.parse(xhr.responseText)
    })
}

/**
 * Delete a company site article featured_image
 *
 * @param {string} companyId
 * @param {string} id
 *
 * @returns {promise}
 */
export function deleteCompanySiteArticleImage(companyId, siteId, id) {
  return Ajax.request({
    url: `${articlePath(companyId, siteId, id)}/featured_image`,
    method: 'DELETE'
  })
}

/**
 * Delete a company site article,
 *
 * @param {string} companyId
 * @param {string} siteId
 * @param {string} id
 *
 * @returns {promise}
 */
export function deleteCompanySiteArticleData(companyId, siteId, id) {
  return Ajax.request({
    url: articlePath(companyId, siteId, id),
    method: 'DELETE'
  })
}
